module.exports = "a:link {\n    text-decoration: none;\n}\n\na.dates {\n    line-height: 1.5;\n}\n\n.date-body > p {\n    font-size: 14px;\n}\n"